import React, { useEffect } from "react";
import { Text, Header2 } from "../../styles/Components";
import styled from "@emotion/styled";
import BackgroundText from "../../../public/gift-printable/gift_text.png";
import GiftImage from "../../../public/gift-printable/gift.jpg";
import Logo from "../../../public/gift-printable/glamsquad-logo.svg";
import Image from "next/image";
import Head from "next/head";

const PrintableContainer = styled.div`
  overflow: hidden;
  width: 100vw;
  height: 100vh;

  @media print {
    @page {
      size: landscape;
    }
  }


  .background-text {
    position: absolute;
    z-index: 0;
    opacity: 50%;
    width: 100%;
    height: 100%;
    overflow: hidden;
    img {
      height: auto !important;
      width: 100%;
    }
  }

  .content {
    padding: 58px;
    background-color: #07218f;
    width: 100%;
    height: 100%;
    display: flex;
    flex: 1;
    text-align: center;
    gap: 3rem;

    .left-content {
      z-index: 999;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      flex-basis: 60%;

      .header-content {
        display: flex;
        flex: 1;
        width: 100%;
        gap: 22px;

        .gift-details {
          flex: 1;
          display: flex;
          flex-direction: column;
          gap: 16px;
          align-items: center;
        }
      }

      .gift-title {
        max-width: 75%;
        text-wrap: wrap;
        text-transform: uppercase;
        margin: 16px 0;
      }

      .text-container {
        background-color: white;
        padding: 18px;
        p {
          color: black;
          text-align: left;
        }
      }

      .body {
        padding-bottom: 2rem;
      }

      .gift-content {
        display: flex;
        flex-direction: column;
        gap: 15px;
        flex: 1;
        margin: 16px 0;
      }

      .content-disclaimer {
        max-width: 75%;
      }
    }

    .image-container {
      flex-basis: 40%;
      position: relative;
      img {
        object-fit: cover;
      }
    }
  }
`;

const GiftPrintable = ({ gift, isHeadless }) => {
  const downloadPDF = async () => {
    try {
      const currentURL = window.location.href; // Current URL
      const response = await fetch(`/api/generate-pdf?url=${encodeURIComponent(currentURL)}`);

      if (!response.ok) {
        console.error("Failed to download PDF");
        return;
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = url;
      link.download = "gift_of_glam.pdf"; // Set the filename

      link.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading PDF:", error);
    }
  };

  useEffect(() => {
    if (!isHeadless) {
      downloadPDF()
    }
  }, [isHeadless])

  return (
    <>
      <Head>
        <title>Glamsquad | The gift of glam</title>
      </Head>
      <PrintableContainer id="printable-page">
        <div className="background-text">
          <Image fill alt="" aria-hidden="true" src={BackgroundText} />
        </div>
        <div className="content">
          <div className="left-content">
            <div className="header-content">
              <div className="gift-details">
                <div className="logo-container">
                  <Image alt="GLAMSQUAD" src={Logo} />
                </div>
                <Text color="white">The gift of glam</Text>
                <Header2 align="center" className="gift-title" color="#F8CBC5">
                  {gift?.emailTitle}
                </Header2>
                <Header2 fontSize={24} align="center" color="white">
                  CODE: {gift?.claimCode}
                </Header2>
              </div>
            </div>
            <div className="gift-content">
              <div className="text-container">
                <Text>To: {gift?.receiverName}</Text>
              </div>
              <div className="text-container">
                <Text>From: {gift?.senderName}</Text>
              </div>
              <div className="text-container body">
                <Text>{gift?.messageBody}</Text>
              </div>
            </div>
            <div className="content-disclaimer">
              <Text fontSize={12} color="white">
                Tax & gratuity included.
              </Text>
              <Text fontSize={12} color="white">
                Enter code on the glamsquad app or on glamsquad.com/book to
                redeem credits and book!
              </Text>
            </div>
          </div>
          <div className="image-container">
            <Image fill src={GiftImage} alt="GLAMSQUAD gift card" webp />
          </div>
        </div>
      </PrintableContainer>
    </>
  );
};

export default GiftPrintable;

// Server-side rendering to fetch data
export async function getServerSideProps(context) {
  const { gift, isHeadless } = context.query;

  // Decode the gift data from the query parameter
  const decodedGift = gift ? JSON.parse(Buffer.from(gift, "base64").toString("utf8")) : null;

  return {
    props: {
      gift: decodedGift,
      isHeadless: isHeadless === 'true'
    },
  };
}

